/* eslint-disable react/no-unknown-property */
import { Wrap } from '../../components/wap'

export const HistoryDetail = () => {
  return (
    <Wrap>
      <div className='nr_banner'>
        <img
          alt=''
          className='text'
          src='https://static-download.globalcrown.com.cn/website/original/d/file/p/2023/02-15/5da10e9d8be099f9c24d6a1c410c596f.jpg'
        />
        <h2 className='wow fadeInUp animated'>发展历史</h2>
        <p className='small_title fb25 wow fadeInUp animated'>
          系统仿真工业软件和数字孪生解决方案提供商
        </p>

        <div className='scroll_hint'>
          <div className='iconfont'>&#xe754;</div>
          <div className='tex'>向下滑动</div>
        </div>
        <span />
      </div>

      <div className='lm_nav'>
        <div className='position-right cl'>
          <dt className='flex-container-row align-center'>
            <img
              alt='首页'
              src='https://static-download.globalcrown.com.cn/website/original/template/images/index.png'
            />{' '}
            <a href='/'>Home</a>&nbsp; &gt; &nbsp;<a href='/about/'>关于我们</a>&nbsp; &gt; &nbsp;
            <a href='/history/'>发展历史</a>
          </dt>
        </div>

        <div className='lm_nav_ul_li'>
          <ul className='lm_nav_ul_li'>
            <li className='lm102'>
              <a href='/about/'>企业介绍</a>
            </li>
            <li className='lm103'>
              <a href='/history/'>发展历史</a>
            </li>
            <li className='lm123'>
              <a href='/contact/'>联系我们</a>
            </li>
            <li className='lm124'>
              <a href='/job/'>加入我们</a>
            </li>
          </ul>

          <div className='line' />
        </div>
      </div>

      <div className='history'>
        <div className='container'>
          <div className='history-hd text-center'>
            <div>
              <i>
                Global Crown
                <br />
                <b>IN 2003</b>
              </i>
            </div>
          </div>
          <ul className='history-bd'>
            <li className='clearfix wow fadeInUp animated' data-wow-delay='0.1s'>
              <div className='year'>
                <span>
                  <svg
                    className='icon'
                    height='128'
                    p-id='4387'
                    // t='1672841581489'
                    version='1.1'
                    viewBox='0 0 1024 1024'
                    width='128'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M512 0C229.696 0 0 229.696 0 512c0 282.282667 229.696 512 512 512 282.282667 0 512-229.717333 512-512C1024 229.696 794.282667 0 512 0zM512 981.269333C253.269333 981.269333 42.730667 770.730667 42.730667 512S253.269333 42.730667 512 42.730667 981.269333 253.269333 981.269333 512 770.730667 981.269333 512 981.269333z'
                      p-id='4388'
                    />
                    <path
                      d='M766.741333 227.050667l-204.650667 204.629333c-14.592-9.130667-31.658667-14.656-50.112-14.656-18.453333 0-35.541333 5.504-50.133333 14.656l-94.250667-94.250667c-8.362667-8.362667-21.845333-8.362667-30.208 0s-8.362667 21.866667 0 30.229333l94.250667 94.250667c-9.130667 14.570667-14.634667 31.658667-14.634667 50.090667 0 52.352 42.581333 94.933333 94.954667 94.933333 52.330667 0 94.933333-42.581333 94.933333-94.933333 0-18.432-5.504-35.52-14.634667-50.090667l204.650667-204.650667c8.384-8.362667 8.384-21.845333 0-30.208S775.125333 218.688 766.741333 227.050667zM512 564.202667c-28.778667 0-52.224-23.424-52.224-52.202667 0-28.778667 23.424-52.224 52.224-52.224 28.8 0 52.202667 23.445333 52.202667 52.224C564.202667 540.8 540.8 564.202667 512 564.202667z'
                      p-id='4389'
                    />
                  </svg>
                </span>
                <i>2024</i>
              </div>
              <div className='article'>
                <i>2024</i>
                <p>
                  发布GCKontrol&GCAir 9.0，取得ISO 26262认证
                  <br />
                  引领行业国产替代 实现公司业务高速增长
                </p>
              </div>
            </li>
            <li className='clearfix wow fadeInUp animated' data-wow-delay='0.2s'>
              <div className='year'>
                <span>
                  <svg
                    className='icon'
                    height='128'
                    p-id='4387'
                    // t='1672841581489'
                    version='1.1'
                    viewBox='0 0 1024 1024'
                    width='128'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M512 0C229.696 0 0 229.696 0 512c0 282.282667 229.696 512 512 512 282.282667 0 512-229.717333 512-512C1024 229.696 794.282667 0 512 0zM512 981.269333C253.269333 981.269333 42.730667 770.730667 42.730667 512S253.269333 42.730667 512 42.730667 981.269333 253.269333 981.269333 512 770.730667 981.269333 512 981.269333z'
                      p-id='4388'
                    />
                    <path
                      d='M766.741333 227.050667l-204.650667 204.629333c-14.592-9.130667-31.658667-14.656-50.112-14.656-18.453333 0-35.541333 5.504-50.133333 14.656l-94.250667-94.250667c-8.362667-8.362667-21.845333-8.362667-30.208 0s-8.362667 21.866667 0 30.229333l94.250667 94.250667c-9.130667 14.570667-14.634667 31.658667-14.634667 50.090667 0 52.352 42.581333 94.933333 94.954667 94.933333 52.330667 0 94.933333-42.581333 94.933333-94.933333 0-18.432-5.504-35.52-14.634667-50.090667l204.650667-204.650667c8.384-8.362667 8.384-21.845333 0-30.208S775.125333 218.688 766.741333 227.050667zM512 564.202667c-28.778667 0-52.224-23.424-52.224-52.202667 0-28.778667 23.424-52.224 52.224-52.224 28.8 0 52.202667 23.445333 52.202667 52.224C564.202667 540.8 540.8 564.202667 512 564.202667z'
                      p-id='4389'
                    />
                  </svg>
                </span>
                <i>2019</i>
              </div>
              <div className='article'>
                <i>2019</i>
                <p>
                  引领行业发展，加高技术壁垒 自主研发GCAir，持续推出1.0-5.0版本；
                  软件成功应用于多家航空航天头部用户， 为软件产业化打下基础。
                </p>
              </div>
            </li>
            <li className='clearfix wow fadeInUp animated' data-wow-delay='0.3s'>
              <div className='year'>
                <span>
                  <svg
                    className='icon'
                    height='128'
                    p-id='4387'
                    // t='1672841581489'
                    version='1.1'
                    viewBox='0 0 1024 1024'
                    width='128'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M512 0C229.696 0 0 229.696 0 512c0 282.282667 229.696 512 512 512 282.282667 0 512-229.717333 512-512C1024 229.696 794.282667 0 512 0zM512 981.269333C253.269333 981.269333 42.730667 770.730667 42.730667 512S253.269333 42.730667 512 42.730667 981.269333 253.269333 981.269333 512 770.730667 981.269333 512 981.269333z'
                      p-id='4388'
                    />
                    <path
                      d='M766.741333 227.050667l-204.650667 204.629333c-14.592-9.130667-31.658667-14.656-50.112-14.656-18.453333 0-35.541333 5.504-50.133333 14.656l-94.250667-94.250667c-8.362667-8.362667-21.845333-8.362667-30.208 0s-8.362667 21.866667 0 30.229333l94.250667 94.250667c-9.130667 14.570667-14.634667 31.658667-14.634667 50.090667 0 52.352 42.581333 94.933333 94.954667 94.933333 52.330667 0 94.933333-42.581333 94.933333-94.933333 0-18.432-5.504-35.52-14.634667-50.090667l204.650667-204.650667c8.384-8.362667 8.384-21.845333 0-30.208S775.125333 218.688 766.741333 227.050667zM512 564.202667c-28.778667 0-52.224-23.424-52.224-52.202667 0-28.778667 23.424-52.224 52.224-52.224 28.8 0 52.202667 23.445333 52.202667 52.224C564.202667 540.8 540.8 564.202667 512 564.202667z'
                      p-id='4389'
                    />
                  </svg>
                </span>
                <i>2014</i>
              </div>
              <div className='article'>
                <i>2014</i>
                <p>
                  自主研发国产软件，成就客户创新梦想
                  <br />
                  建立国内系统仿真技术服务标准
                </p>
              </div>
            </li>
            <li className='clearfix wow fadeInUp animated' data-wow-delay='0.4s'>
              <div className='year'>
                <span>
                  <svg
                    className='icon'
                    height='128'
                    p-id='4387'
                    // t='1672841581489'
                    version='1.1'
                    viewBox='0 0 1024 1024'
                    width='128'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M512 0C229.696 0 0 229.696 0 512c0 282.282667 229.696 512 512 512 282.282667 0 512-229.717333 512-512C1024 229.696 794.282667 0 512 0zM512 981.269333C253.269333 981.269333 42.730667 770.730667 42.730667 512S253.269333 42.730667 512 42.730667 981.269333 253.269333 981.269333 512 770.730667 981.269333 512 981.269333z'
                      p-id='4388'
                    />
                    <path
                      d='M766.741333 227.050667l-204.650667 204.629333c-14.592-9.130667-31.658667-14.656-50.112-14.656-18.453333 0-35.541333 5.504-50.133333 14.656l-94.250667-94.250667c-8.362667-8.362667-21.845333-8.362667-30.208 0s-8.362667 21.866667 0 30.229333l94.250667 94.250667c-9.130667 14.570667-14.634667 31.658667-14.634667 50.090667 0 52.352 42.581333 94.933333 94.954667 94.933333 52.330667 0 94.933333-42.581333 94.933333-94.933333 0-18.432-5.504-35.52-14.634667-50.090667l204.650667-204.650667c8.384-8.362667 8.384-21.845333 0-30.208S775.125333 218.688 766.741333 227.050667zM512 564.202667c-28.778667 0-52.224-23.424-52.224-52.202667 0-28.778667 23.424-52.224 52.224-52.224 28.8 0 52.202667 23.445333 52.202667 52.224C564.202667 540.8 540.8 564.202667 512 564.202667z'
                      p-id='4389'
                    />
                  </svg>
                </span>
                <i>2009</i>
              </div>
              <div className='article'>
                <i>2009</i>
                <p>
                  立足自身技术实力，解决客户实际难题
                  <br />
                  2005年起，连续5年保持每年100%的销售增长率
                </p>
              </div>
            </li>
            <li className='clearfix wow fadeInUp animated' data-wow-delay='0.5s'>
              <div className='year'>
                <span>
                  <svg
                    className='icon'
                    height='128'
                    p-id='4387'
                    // t='1672841581489'
                    version='1.1'
                    viewBox='0 0 1024 1024'
                    width='128'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M512 0C229.696 0 0 229.696 0 512c0 282.282667 229.696 512 512 512 282.282667 0 512-229.717333 512-512C1024 229.696 794.282667 0 512 0zM512 981.269333C253.269333 981.269333 42.730667 770.730667 42.730667 512S253.269333 42.730667 512 42.730667 981.269333 253.269333 981.269333 512 770.730667 981.269333 512 981.269333z'
                      p-id='4388'
                    />
                    <path
                      d='M766.741333 227.050667l-204.650667 204.629333c-14.592-9.130667-31.658667-14.656-50.112-14.656-18.453333 0-35.541333 5.504-50.133333 14.656l-94.250667-94.250667c-8.362667-8.362667-21.845333-8.362667-30.208 0s-8.362667 21.866667 0 30.229333l94.250667 94.250667c-9.130667 14.570667-14.634667 31.658667-14.634667 50.090667 0 52.352 42.581333 94.933333 94.954667 94.933333 52.330667 0 94.933333-42.581333 94.933333-94.933333 0-18.432-5.504-35.52-14.634667-50.090667l204.650667-204.650667c8.384-8.362667 8.384-21.845333 0-30.208S775.125333 218.688 766.741333 227.050667zM512 564.202667c-28.778667 0-52.224-23.424-52.224-52.202667 0-28.778667 23.424-52.224 52.224-52.224 28.8 0 52.202667 23.445333 52.202667 52.224C564.202667 540.8 540.8 564.202667 512 564.202667z'
                      p-id='4389'
                    />
                  </svg>
                </span>
                <i>2003</i>
              </div>
              <div className='article'>
                <i>2003</i>
                <p>引进国际先进技术，服务国内工业用户</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </Wrap>
  )
}
